var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Diet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_07_diet",
    "data-name": "07_diet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.69,442.84,201.09,292.1l-22-49.89a11.28,11.28,0,0,0-16-5.21A296.53,296.53,0,0,0,59.42,337.68a11.27,11.27,0,0,0,4.71,16.13l198,94.48A4.17,4.17,0,0,0,267.69,442.84Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.33,163.18V99.23c0-7,5.28-12.75,11.8-12.75h56.6a5.56,5.56,0,0,1,5.34,5.77v6.54a5.56,5.56,0,0,1-5.34,5.76H381.46a1.8,1.8,0,0,0-1.73,1.87v56.76",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.09,396.85H284.71a.56.56,0,0,1-.58-.5l-12.5-219.5a.56.56,0,0,1,.57-.56H422.64a.56.56,0,0,1,.57.56L411.66,396.34A.56.56,0,0,1,411.09,396.85Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.57 175.88 275.45 224.93 277.96 289.03 417.57 175.88 343.57 175.88",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,146V89.13a19.88,19.88,0,0,1,19.88-19.88h57.63a2.19,2.19,0,0,1,2.2,2.2V85.13a2.19,2.19,0,0,1-2.2,2.19H369.66a9,9,0,0,0-9,9V146",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 144.75,
    width: 168.87,
    height: 29.49,
    rx: 0.53,
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.72,
    y: 388.75,
    width: 115.98,
    height: 26.2,
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.2 298.46 284.75 396.35 284.75 396.35 341.86 396.35 411.66 396.35 417.2 298.46",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.02 267.69 283.06 371.47 283.8 384.44 418.2 283.33 420.02 267.69",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.67,247.89l-27.48-12.71a3.16,3.16,0,0,1-1.55-4.2l12.71-27.48a3.16,3.16,0,0,1,4.2-1.55L343,214.66a3.16,3.16,0,0,1,1.55,4.2l-12.7,27.48A3.18,3.18,0,0,1,327.67,247.89Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.36,377.72,305.88,365a3.18,3.18,0,0,1-1.55-4.21L317,333.33a3.16,3.16,0,0,1,4.2-1.55l27.49,12.71a3.17,3.17,0,0,1,1.54,4.2l-12.7,27.48A3.18,3.18,0,0,1,333.36,377.72Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.33,304.89l-29.94,4.49a3.17,3.17,0,0,1-3.61-2.66l-4.49-30a3.17,3.17,0,0,1,2.66-3.6l29.95-4.49a3.16,3.16,0,0,1,3.6,2.66l4.49,30A3.17,3.17,0,0,1,395.33,304.89Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.91,410.61l-66.6-150.74-22-49.89a11.28,11.28,0,0,0-16-5.21A296.67,296.67,0,0,0,52.63,305.45a11.29,11.29,0,0,0,0,4.72,16.14l198,94.47A4.17,4.17,0,0,0,260.91,410.61Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.71,339.06a10.74,10.74,0,1,1,10.89-10.57A10.72,10.72,0,0,1,140.71,339.06Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,362.47a10.74,10.74,0,1,1,10.9-10.57A10.73,10.73,0,0,1,223,362.47Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23,230.28c-6.9,10.15-3.29,17.58-15.08,29-14,13.56-21.76,5.62-35.78,19.18S124.1,300,110.09,313.53c-13.27,12.84-20.92,6.4-33.6,17.2l-19.15-9.14a11.29,11.29,0,0,1-4.71-16.14A296.39,296.39,0,0,1,156.3,204.78a11.26,11.26,0,0,1,16,5.21Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.31,359.66a7.92,7.92,0,1,1,11.2.16A7.93,7.93,0,0,1,182.31,359.66Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.55,302.29a7.92,7.92,0,1,1,11.2.16A7.94,7.94,0,0,1,175.55,302.29Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,344h-.25a16.86,16.86,0,1,1,.25,0Zm-.07-12h.07a4.73,4.73,0,1,0-3.4-1.43,4.66,4.66,0,0,0,3.33,1.43Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.4,408.18,177.76,207.56a17.29,17.29,0,0,0-24.46-8A302.53,302.53,0,0,0,47.53,302.29,17.29,17.29,0,0,0,54.77,327l197.94,94.47a10.22,10.22,0,0,0,4.42,1,10.19,10.19,0,0,0,9.27-14.3ZM223.18,348.1a4.74,4.74,0,0,1-.07,9.47H223a4.73,4.73,0,0,1-4.66-4.81,4.71,4.71,0,0,1,4.73-4.66Zm-166-35.2a5.27,5.27,0,0,1,.58-4.29A290.53,290.53,0,0,1,159.31,210a5.18,5.18,0,0,1,2.63-.72,5.28,5.28,0,0,1,1.65.27,5.19,5.19,0,0,1,3.19,2.89L173.23,227c-5.74,6.49-7.33,12-8.74,16.92s-2.51,8.78-8,14.17-9.29,6.39-14.15,7.66c-5.52,1.45-11.78,3.1-19.51,10.72s-9.51,13.88-11.1,19.42c-1.4,4.91-2.51,8.78-8,14.17s-9.29,6.38-14.14,7.66c-4.13,1.08-8.66,2.27-13.92,6l-15.78-7.53A5.18,5.18,0,0,1,57.15,312.9ZM89.4,330.23c1.06-.32,2.14-.61,3.28-.91,5.52-1.45,11.78-3.09,19.51-10.71s9.51-13.88,11.1-19.42c1.4-4.91,2.51-8.79,8-14.18s9.29-6.38,14.14-7.65c5.53-12.06,0-19.05,3.19-30.79,9.49l-40.78,24.45,8.23,14.74,42.64,96.5a16.73,16.73,0,0,0,1.64,33.38,16.73,16.73,0,0,0,11.2-4.31l19.11,43.26ZM311,360.76l22.34,10.33,10.33-22.34L321.3,338.42Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.06,420.93l-47.82-43,10.31-196.47h2.39a6.53,6.53,0,0,0,6.53-6.52V146.5a6.54,6.54,0,0,0-6.53-6.53H366.66V96.36a3,3,0,0,1,3-3h49.71a8.2,8.2,0,0,0,8.2-8.19V71.49a8.21,8.21,0,0,0-8.2-8.2H361.74a25.91,25.91,0,0,0-25.88,25.88V140H264.12a6.54,6.54,0,0,0-6.53,6.53v28.44a6.53,6.53,0,0,0,6.53,6.52h2.42l3.54,62.34L85.44,77.78l-8,8.92L271,260.81l7.71,135.87a6.54,6.54,0,0,0,3.09,5.18v7.89A11.21,11.21,0,0,0,293,421H403a11.22,11.22,0,0,0,11.21-11.2v-7.4a6.54,6.54,0,0,0,4-5.69l.18-3.32L459,429.85ZM348.8,84.19,355.66,91a14.68,14.68,0,0,0-1,5.1h-6.82v-7A13.74,13.74,0,0,1,348.8,84.19Zm66.77-2.83H381.68V75.29h33.89Zm-45.89-6.07v6.07h0a14.77,14.77,0,0,0-5.61,1.11L357.53,76a13.64,13.64,0,0,1,4.21-.66Zm-21.82,32.85h6.8V140h-6.8ZM269.59,152H426.47v17.49H269.59Zm9,29.49h139l-9.76,186.15-125-112.42ZM402.23,409H293.84v-6.1H402.23Zm4.32-18.1H290.44l-6.73-118.66L407,383Z",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiet);
export default __webpack_public_path__ + "static/media/diet.ad265962078d0eb32ec1e02183fade08.svg";
export { ForwardRef as ReactComponent };